import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb, Table, Grid } from 'semantic-ui-react';
import { Helmet } from "react-helmet";


import CustomDivider from '../../components/extras/CustomDivider';
import TableSalesByCategory from '../../components/charts/TableSalesByCategory';
import FilterBar from '../../components/reports/FilterBar';
import AlertUpgrade from "../../components/extras/AlertUpgrade";
import localDB from "../../data/localDB";
import UpgradeAccount from "../../components/extras/UpgradeAccount";

class ProductCategories extends Component {

    loadData = (branch_office, date) => {
        if (!localDB.checkPlanAccessExclude('reports_view_all')) {
            this.refs.sales_day_chart.loadData(branch_office, 'd', date);
            this.refs.sales_week_chart.loadData(branch_office, 'w', date);
            this.refs.sales_month_chart.loadData(branch_office, 'm', date);
            this.refs.sales_year_chart.loadData(branch_office, 'y', date);
        } else {
            this.refs.alert_upgrade.open();
        }
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>Ventas por Categorías - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/reports'>Informes</Breadcrumb.Section>
                    <Breadcrumb.Divider />
                    <Breadcrumb.Section active>Ventas por Categorías</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider />
                {!localDB.checkPlanAccessExclude('ticket_service') ? <Table>
                    <FilterBar title='Ventas por Categorías' callbackGetFilter={this.loadData} />
                    <Table.Body>
                        <Table.Row>
                            <Grid stackable textAlign='center'>
                                <Grid.Row columns={2}>
                                    <Grid.Column>
                                        <TableSalesByCategory
                                            title='Ventas por Día'
                                            id='sales_day_chart'
                                            ref='sales_day_chart'
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <TableSalesByCategory
                                            title='Ventas por Semana'
                                            id='sales_week_chart'
                                            ref='sales_week_chart'
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row columns={2}>
                                    <Grid.Column>
                                        <TableSalesByCategory
                                            title='Ventas por Mes'
                                            id='sales_month_chart'
                                            ref='sales_month_chart'
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <TableSalesByCategory
                                            title='Ventas por Año'
                                            id='sales_year_chart'
                                            ref='sales_year_chart'
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Table.Row>
                    </Table.Body>
                </Table> : <UpgradeAccount />}
                <AlertUpgrade ref='alert_upgrade' />
            </div>
        );
    }
}

export default ProductCategories;



// WEBPACK FOOTER //
// ./src/containers/reports/ProductCategories.js